import React, { Fragment } from "react";
import { FormFeedback } from 'reactstrap'
import { Check, AlertCircle } from "react-feather";

export const ValidatorMark = ({ val, name, validation, errors, textOnly = false})=> {

  if(!val && !errors[name]) return null;

  const mark = validation(name, val);

  return (
    <Fragment>
      { errors[name] && <FormFeedback> {errors[name]} </FormFeedback> }
      { !textOnly  && <div className="validation-mark">
        { errors[name]  && <AlertCircle className="text-danger"/> }
        { !mark && !errors[name] && <Check className="text-success"/> }
      </div> }
    </Fragment>
  );
}


export default {
  ValidatorMark
}
